module.exports = __webpack_public_path__ + "img/IMG_0223.1949baf3.jpg";